import gql from "graphql-tag";

export const importExperiencesCatalogMutation = gql`
    mutation ImportExperiencesCatalogMutation($data: [ImportExperienceInput]) {
        importExperienceCatalog(data: $data)
    }
`;
